import styled from '@emotion/styled';

import Icon from 'components/global/Icon';

import { Breakpoints } from 'utils/const.styles';

export const FeaturesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 9.5rem;
	margin-top: 1.8rem;
	@media ${Breakpoints.mobile} {
		grid-template-columns: 2fr;
		gap: 3.4rem;
	}
`;

export const Feature = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 1.8rem;
`;
export const FeatureIcon = styled(Icon)`
	color: var(--green);
`;

export const FeatureContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	line-height: 2.15rem;
`;
